// utils/conversationHelpers.js

import { callAzureOpenAI } from "./azureOpenAI";

/**
 * Creates a new conversation object with a unique ID.
 */
export function createNewConversation() {
  const newId = Date.now().toString();
  return {
    id: newId,
    title: "",
    messages: [],
    lastMessage: new Date().toLocaleString(),
    createdAt: new Date().toISOString(),
  };
}

/**
 * Updates the title of a conversation based on the first user message.
 */
export async function updateConversationTitle(conversations, setConversations, currentConversationId, messages) {
  if (messages.length === 2) {
    const firstMessage = messages[0].content;

    const titlePrompt = [
      {
        role: "system",
        content: "Generate a concise 4-6 word title for this code-related question. Focus on the main technical topic.",
      },
      { role: "user", content: `Generate a title for: "${firstMessage}"` },
    ];

    try {
      const title = await callAzureOpenAI(titlePrompt);
      const cleanTitle = title.replace(/["']/g, "").trim();

      setConversations(prev =>
        prev.map(conv =>
          conv.id === currentConversationId
            ? { ...conv, title: cleanTitle, lastMessage: new Date().toLocaleString() }
            : conv
        )
      );
    } catch {
      const fallback = firstMessage.length > 35 ? firstMessage.slice(0, 35) + "..." : firstMessage;
      setConversations(prev =>
        prev.map(conv => (conv.id === currentConversationId ? { ...conv, title: fallback } : conv))
      );
    }
  }
}
